<template>
    <router-link :to="{name: 'surveys.'+notification.data.type+'.fill', params: {survey_id: notification.data.id, kindergarten_id: notification.kindergarten_id, org_id: notification.org_id}}" class="card p-3 mb-2 diary-likes diary-likes e3-notification-row">
        <div>
            <span v-if="notification.kindergarten" class="font-weight-bold">{{ notification.kindergarten.name }}</span>
            <span v-else-if="notification.organization" class="font-weight-bold">{{ notification.organization.name }}</span>
            <span v-else class="font-weight-bold">ELIIS</span>
            <span> {{$t('Notification - New survey', {survey: this.notification.data.name})}}</span>
        </div>
        <div class="text-muted">
            {{ formatDateTime(notification.created_at) }}
        </div>
    </router-link>
</template>

<script>
import {formatDateTime} from '@/filters';

export default {
    name: 'SurveyNotification',
    props: {
        notification: Object
    },
    methods: {
        formatDateTime // TODO: Vue3 remove
    }
};
</script>

<style scoped>

</style>
